<template>
  <div class="page_salary page_approvalDtl">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>审批列表</el-breadcrumb-item> -->
          <el-breadcrumb-item>{{baseInfo.ProcessState}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName2" type="card" @tab-click="changeTab">
          <el-tab-pane label="审批内容" name="0"></el-tab-pane>
          <el-tab-pane label="工作流" name="1"></el-tab-pane>
          <el-tab-pane label="流程记录" name="2"></el-tab-pane>
        </el-tabs>

        <div v-if="!isNull(baseInfo)">
          <el-button type="success" size="small" v-if="(baseInfo.ProcessState=='主管审批' || baseInfo.ProcessState=='业务审批') && activeName2=='0'" @click="printClick('printBox','')" style="margin-bottom: 10px;">打印</el-button>
          <div v-if="activeName2=='0'">
            <div class="descriptions_box" id="printBox" v-if="baseInfo.ProcessState=='主管审批'">
              <div class="descriptionsTitle" style="width:798px">{{baseInfo.Subject}}</div>
              <div class="descriptionsTitle" style="color: #666;width:798px">工资发放申请</div>
              <el-descriptions :column="4" border :contentStyle="CS" :label-style="LS " style="width:800px;">

                <el-descriptions-item label="签单部门" :span="2" :contentStyle="{'max-width': '200px','min-width': '200px','text-align': 'center'}">{{baseInfo.StrbusDep}}</el-descriptions-item>
                <el-descriptions-item label="业务员" :span="2">{{baseInfo.StrAchieveowner}}</el-descriptions-item>

                <el-descriptions-item label="服务部门" :span="2">{{baseInfo.StrDep2}}</el-descriptions-item>
                <el-descriptions-item label="客服" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.Service}}</el-descriptions-item>
                <el-descriptions-item label="申请日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.CreateTime ? baseInfo.CreateTime.split('T')[0] : ''}}</el-descriptions-item>

                <el-descriptions-item label="所属项目" :span="2">{{baseInfo.ProjectName}}</el-descriptions-item>
                <el-descriptions-item label="客户名称" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.CustomerName }}</el-descriptions-item>
                <el-descriptions-item label="薪资月份" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{ baseInfo.AttrMonth }}</el-descriptions-item>

                <el-descriptions-item label="内容" :span="2">{{ baseInfo.IncomeTaxType }}</el-descriptions-item>
                <el-descriptions-item label="业务属性" :span="2">{{baseInfo.StrBusitypeName}}</el-descriptions-item>

                <el-descriptions-item label="金额 大写(RMB)" :span="2">{{ numberToChinese(baseInfo.GrandTotal) }}</el-descriptions-item>
                <el-descriptions-item label="￥：" :span="2">{{baseInfo.GrandTotal}}</el-descriptions-item>

                <el-descriptions-item label="备注" :span="4">{{baseInfo.ApplyforRemark}}</el-descriptions-item>

                <el-descriptions-item label="申请人" :span="2">{{ baseInfo.Operator ? baseInfo.Operator == '通道' ? '通道（易海媚）' : baseInfo.Operator : '' }}</el-descriptions-item>
                <el-descriptions-item label="业务审核" :span="2">{{baseInfo.StrAchieveowner}}</el-descriptions-item>

                <el-descriptions-item label="出纳确认" :span="2">{{baseInfo.Cashier}}</el-descriptions-item>
                <el-descriptions-item label="出纳" :span="2">{{baseInfo.Cashier}}</el-descriptions-item>

              </el-descriptions>
            </div>

            <div class="descriptions_box" id="printBox" v-if="baseInfo.ProcessState=='业务审批'">
              <div class="descriptionsTitle" style="width:659px">{{baseInfo.Subject}}</div>
              <div class="descriptionsTitle" style="color: #666;width:659px">工资发放申请</div>
              <el-descriptions :column="3" border :contentStyle="CS" :label-style="LS " style="width:600px;">

                <el-descriptions-item label="发薪渠道" :span="3" :labelStyle="{'max-width': '100px','min-width': '100px','text-align': 'center'}">{{baseInfo.PayrollChannel}}</el-descriptions-item>

                <el-descriptions-item label="到款银行" :span="2">{{ReceivedBankCard}}</el-descriptions-item>
                <el-descriptions-item label="账号" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}" :labelStyle="{'max-width': '100px','min-width': '100px','text-align': 'center'}">{{ReceivedAccountNo}}</el-descriptions-item>

                <el-descriptions-item label="发薪银行" :span="2">{{PaymentCard}}</el-descriptions-item>
                <el-descriptions-item label="账号" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{PaymentAccount}}</el-descriptions-item>

                <el-descriptions-item label="申请日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.CreateTime ? baseInfo.CreateTime.split('T')[0] : ''}}</el-descriptions-item>
                <el-descriptions-item label="申请人" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}" :labelStyle="{'max-width': '100px','min-width': '100px','text-align': 'center'}">{{baseInfo.Operator}}</el-descriptions-item>
                <el-descriptions-item label="申请部门" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.StrDep2}}</el-descriptions-item>

                <el-descriptions-item label="是否垫资" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.NeedApplyDeposit ? '是' : '否'}}</el-descriptions-item>
                <el-descriptions-item label="业务类型" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.StrBusitypeName}}</el-descriptions-item>
                <el-descriptions-item label="发薪日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{ baseInfo.ApplicationDate }}</el-descriptions-item>

                <el-descriptions-item label="项目名称" :span="2">{{baseInfo.ProjectName}}</el-descriptions-item>
                <el-descriptions-item label="客户名称" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.CustomerName }}</el-descriptions-item>

                <el-descriptions-item label="摘要" :span="2">{{baseInfo.ApplicationRemarks}}</el-descriptions-item>
                <el-descriptions-item label="归属月" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.AttrMonth}}</el-descriptions-item>

                <el-descriptions-item label="金额(大写RMB)" :span="2">{{ numberToChinese(baseInfo.GrandTotal) }}</el-descriptions-item>
                <el-descriptions-item label="￥" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.GrandTotal}}</el-descriptions-item>

                <el-descriptions-item label="团队长" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.Strpartner}}</el-descriptions-item>
                <el-descriptions-item label="业绩归属人" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}" :labelStyle="{'max-width': '100px','min-width': '100px','text-align': 'center'}">{{baseInfo.StrAchieveowner}}</el-descriptions-item>
                <el-descriptions-item label="服务中心" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.StrDep2}}</el-descriptions-item>

              </el-descriptions>
            </div>

            <div class="demandForm" v-if="baseInfo.ProcessState=='出纳确认' || baseInfo.ProcessState=='部分发薪' || baseInfo.ProcessState=='待发薪'">
              <el-form :inline="true" label-width="110px">
                <el-form-item label="发薪项目:">{{baseInfo.ProjectName}}</el-form-item>
                <el-form-item label="商务合同主体:">
                  <div class="loongTxt" :title="baseInfo.Subject">
                    {{ baseInfo.Subject }}</div>
                </el-form-item>
                <el-form-item label="申请人:">{{baseInfo.Operator}}</el-form-item>
                <el-form-item label="申请时间:">{{baseInfo.CreateTime.split('T')[0]}}</el-form-item>
                <el-form-item label="归属月:">{{baseInfo.AttrMonth}}</el-form-item>
                <el-form-item label="申报月:">{{baseInfo.IncomeTaxMonth}}</el-form-item>
                <el-form-item label="实发总金额:">{{baseInfo.TotalResponse}}</el-form-item>
                <el-form-item label="发放途径:">{{baseInfo.PayrollChannel}}</el-form-item>
                <el-form-item label="导入表:"> <span v-if="baseInfo.PayScaleRul" @click="down(baseInfo.PayScaleRul)" class="down cp">下载</span></el-form-item>
                <el-form-item label="客户原表:"><span v-if="baseInfo.CustomerOriginalTableRul" @click="down(baseInfo.CustomerOriginalTableRul)" class="down cp">下载</span></el-form-item>
              </el-form>
              <!-- <el-table :data="PaymentData" border class="doc_table" style="width:601px;margin-bottom: 20px;">
                <el-table-column prop="name" label="发薪金额" width="200" :show-overflow-tooltip="true" align="center" fixed="left">
                </el-table-column>
                <el-table-column prop="name" label="商务合同主体" width="200" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="name" label="发薪主体" width="200" :show-overflow-tooltip="true" align="center">
                </el-table-column>
              </el-table> -->
            </div>

            <div v-if="!isNull(baseInfo.AssociatedClaim)">
              <div class="selectCustomPayment">对应客户到款：<el-button type="text" @click="getPaymentInfo">{{ showPaymentInfo ? '收起' :'展开>>'}} </el-button>
              </div>

              <div v-if="showPaymentInfo" class="showPaymentInfo">
                <el-table :data="PaymentData" class="doc_table" style="width:100%;margin-bottom: 20px;">
                  <el-table-column prop="PaymentNum" label="到款编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
                  </el-table-column>
                  <el-table-column prop="TransactionSerialNumber" label="银行卡流水号" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="BankTransactionDate" label="到款时间" width="155" align="center">
                    <template slot-scope={row}>
                      {{ row.BankTransactionDate ? row.BankTransactionDate.replace('T',' ') : '' }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="OppositeOpeningBank" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AccountName" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="IncurredAmount" label="到款金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AmountClaime" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="EmainingAvailableCredit" label="可用金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="Department" label="认领项目" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="OppositeName" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="CreateTime" label="认领时间" width="155" align="center">
                    <template slot-scope={row}>
                      {{ row.CreateTime ? row.CreateTime.replace('T',' ') : '' }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <div v-if="baseInfo.NeedApplyDeposit">
              <div class="selectCustomPayment">垫资申请信息：<el-button type="text" @click="showDZInfo = !showDZInfo">{{ showDZInfo ? '收起' :'展开>>'}}</el-button>
              </div>
              <el-form v-if="showDZInfo" :inline="true">
                <el-form-item label="垫资金额：" label-width="90px">
                  <div class="dzItem">{{baseInfo.ApplyDeposit ? baseInfo.ApplyDeposit + '元' : ''}}</div>
                </el-form-item>
                <el-form-item label="状态：" label-width="60px">
                  <div class="dzItem">待批准</div>
                </el-form-item>
                <el-form-item label="本客户应收款金额合计：" label-width="170px">
                  <div class="dzItem"></div>
                </el-form-item>
                <el-form-item label="本客户垫资未核销金额合计：" label-width="200px">
                  <div class="dzItem"></div>
                </el-form-item>
              </el-form>
            </div>


            <div class="remarkInfo">
              <el-form :model="form1" :inline="true" :rules="rules">
                <el-form-item label="备注" label-width="80px">
                  <div>{{ baseInfo.ApplyforRemark }}</div>
                </el-form-item>
                <div>
                  <el-form-item label="客户原表" label-width="80px">
                    <div v-if="baseInfo.CustomerOriginalTableRul" @click="down(baseInfo.CustomerOriginalTableRul)" class="down cp">下载</div>
                  </el-form-item>
                  <el-form-item label="导入表" label-width="80px">
                    <div v-if="baseInfo.PayScaleRul" @click="down(baseInfo.PayScaleRul)" class="down cp">下载</div>
                  </el-form-item>
                </div>
                <el-form-item v-if="baseInfo.ProcessState!='出纳确认' && baseInfo.ProcessState!='部分发薪' && baseInfo.ProcessState!='待发薪'" label="审批备注" label-width="80px">
                  <el-input v-model="form1.approveRemake" style="width:600px" size="small" type="textarea" maxlength="500" :autosize="{ minRows: 2}" show-word-limit></el-input>
                </el-form-item>
              </el-form>
            </div>

            <div class="descriptions_box" id="printBox" v-if="baseInfo.ProcessState=='出纳确认' || baseInfo.ProcessState=='部分发薪' || baseInfo.ProcessState=='待发薪'">
              <div class="descriptionsTitle" style="width:659px">{{baseInfo.Subject}}</div>
              <div class="descriptionsTitle" style="color: #666;width:659px">工资发放申请</div>
              <el-descriptions :column="3" border :contentStyle="CS" :label-style="LS " style="width:600px;">

                <el-descriptions-item label="发薪渠道" :span="3">{{baseInfo.PayrollChannel}}</el-descriptions-item>

                <el-descriptions-item label="到款银行" :span="2">{{ReceivedBankCard}}</el-descriptions-item>
                <el-descriptions-item label="账号" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{ReceivedAccountNo}}</el-descriptions-item>

                <el-descriptions-item label="发薪公司" :span="3">{{baseInfo.PayrollCompany}}</el-descriptions-item>

                <el-descriptions-item label="申请日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.CreateTime ? baseInfo.CreateTime.split('T')[0] : ''}}</el-descriptions-item>
                <el-descriptions-item label="申请人" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.Operator}}</el-descriptions-item>
                <el-descriptions-item label="申请部门" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.StrDep2}}</el-descriptions-item>

                <el-descriptions-item label="是否垫资" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.NeedApplyDeposit ? '是' : '否'}}</el-descriptions-item>
                <el-descriptions-item label="业务类型" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.StrBusitypeName}}</el-descriptions-item>
                <el-descriptions-item label="发薪日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{ baseInfo.ApplicationDate }}</el-descriptions-item>

                <el-descriptions-item label="项目名称" :span="2">{{baseInfo.ProjectName}}</el-descriptions-item>
                <el-descriptions-item label="客户名称" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.CustomerName }}</el-descriptions-item>

                <el-descriptions-item label="摘要" :span="2">{{baseInfo.ApplicationRemarks}}</el-descriptions-item>
                <el-descriptions-item label="归属月" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.AttrMonth}}</el-descriptions-item>

                <el-descriptions-item label="金额(大写RMB)" :span="2">{{ numberToChinese(baseInfo.GrandTotal) }}</el-descriptions-item>
                <el-descriptions-item label="￥" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.GrandTotal}}</el-descriptions-item>

                <el-descriptions-item label="团队长" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.Strpartner}}</el-descriptions-item>
                <el-descriptions-item label="业绩归属人" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.StrAchieveowner}}</el-descriptions-item>
                <el-descriptions-item label="服务中心" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{baseInfo.StrDep2}}</el-descriptions-item>

              </el-descriptions>
            </div>
          </div>

          <div v-if="activeName2=='1' && this.WorkerList.length>0">
            <div style="margin-left:30px">
              <el-steps direction="vertical" :active="TrackList.length" finish-status="success">
                <el-step v-for="(item,index) in WorkerList" :key="index" :title="item.title" :description="item.description"></el-step>
              </el-steps>
            </div>
          </div>

          <div class="timelineBox" v-if="activeName2=='2'">
            <el-timeline>
              <el-timeline-item :v-bind="item.NDToT " placement="top" v-for="(item,index) in TrackList" :key="index">
                <el-card>
                  <p>时间：{{ item.RDT }}</p>
                  <p>记录：{{ item.NDFromT }} <span v-if="item.Msg" style="margin-left: 20px;">备注： {{ item.Msg }}</span> </p>
                  <p>处理人：{{ item.EmpFromT }}</p>
                  <!-- <p>备注：XXXXX</p> -->
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>

          <div class="btnBox">
            <el-button @click="goback">取 消</el-button>
            <el-button type="danger" v-preventReClick style="margin-left:10px;" @click="disagree">退回上一步</el-button>
            <!-- <el-button type="danger" v-preventReClick style="margin-left:10px;" @click="disagree">不同意</el-button> -->
            <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="agree()" :loading="btnLoading">同 意</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="审批" :visible.sync="showApplication" width="400px" :show-close="false">
      <div class="payTips2">该笔发薪本月批次为 {{this.ThisMonthBatch ? this.ThisMonthBatch : ' 1 '}},请注意核对</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showApplication = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAgree" :loading="btnLoading">确认同意</el-button>
      </span>
    </el-dialog>

    <el-dialog title="系统风控提醒" :visible.sync="showSysTips" width="815px" :show-close="false">
      <div class="payTips2">本项目系统已存在相同提交月份+相同卡号+相同金额或相同归属月份+相同卡号+相同金的发薪数据，请确认。</div>
      <el-table :data="sysTipsData" class="doc_table" max-height="700px" style="width:100%;margin-bottom: 6px;" :loading="sysLoading">
        <el-table-column prop="projectName" label="项目名称" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="updataTime" label="发生时间" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="employeeName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="bankAccount" label="卡号" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="issuedThisMonth" label="金额" min-width="140" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>{{row.issuedThisMonth ? '￥' + row.issuedThisMonth : ''}}</template>
        </el-table-column>
        <el-table-column prop="attrMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="processState" label="发薪状态" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination v-if="sysTotal > 0" @current-change="currentChangeSys" :current-page.sync="sysQuery.PageNumber" :page-size="Number(sysQuery.PageSize)" @size-change="handleSizeChangeSys" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="sysTotal"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSysTips = false" size="small">取 消</el-button>
        <el-button type="danger" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAgree" :loading="btnLoading">确认，继续</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import print from 'print-js'
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          pageNum: 1,
          pageSize: 10,
          id: '',
          WorkId: '',
          CardId: '', //身份证
          EmployeeName: '', //姓名
          BankAccount: '', //银行卡
        },
        tableData: [],
        showSysTips: false,
        sysQuery: {
          id: '',
          PageNumber: 1,
          PageSize: 10
        },
        sysLoading: false,
        sysTotal: 0,
        sysTipsData: [],
        rules: {
          approveRemake: {
            required: true,
            message: '请输入审批备注',
            trigger: 'change'
          },
        },
        roletype: localStorage.loginRoletype,
        headPath: this.$store.state.EMP.tablePath,
        totalCount: 0,
        activeName: '1',
        loading: false,
        btnLoading: false,
        activeName2: '0',
        showApprove: false,
        showPaymentInfo: false,
        showDZInfo: false,
        active: 4,
        formData: {
          name: ''
        },
        PaymentCard: '', //发薪银行卡
        PaymentAccount: '', //发薪账号
        ReceivedBankCard: '', //到款银行卡
        ReceivedAccountNo: '', //到款账号
        PaymentData: [],
        baseInfo: {},
        form1: {
          approveRemake: '', //审批备注
        },
        WorkerList: [{
          title: '发起流程',
          description: '',
        }, {
          title: '主管审批',
          description: '',
        }, {
          title: '业务审批',
          description: '',
        }, {
          title: '出纳确认',
          description: '',
        }, {
          title: '待打款',
          description: '',
        }, {
          title: '部分打款',
          description: '',
        }, {
          title: '已打款',
          description: '',
        }], //工作流
        type: '',
        TrackList: [], //流程记录
        ThisMonthBatch: '',
        showApplication: false,
        CS: {
          'text-align': 'center', //文本居中
          'min-width': '200px', //最小宽度
          'max-width': '200px',
          'word-break': 'break-all'
        },
        LS: {
          'background-color': 'fff',
          'text-align': 'center', //文本居中
          'min-width': '100px', //最小宽度
          'max-width': '100px',
        },
      }
    },
    created() {
      if (this.$route.query.WorkID != undefined && this.$route.query.WorkID) {
        this.listQuery.WorkId = this.$route.query.WorkID;
        this.type = 'work';
        // this.dtlType = this.$route.query.type;
      } else if (this.$route.query.Id != undefined && this.$route.query.Id) {
        this.listQuery.id = this.$route.query.Id;
        this.type = 'id';
        // this.dtlType = this.$route.query.type;
      }
      this.getApplicationPayrollDetail();
    },
    methods: {
      checkPermission,
      getApplicationPayrollDetail() {
        xz.getApplicationPayrollDetail(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.baseInfo = res.data.data;
            this.tableData = res.data.ApproveringList;
            this.listQuery.WorkId = res.data.data.WorkId;
            if(this.baseInfo.ApprovalRemark){
              this.form1.approveRemake = this.baseInfo.ApprovalRemark;
            }
            console.log(this.baseInfo)
            let PaymentCard = eval(res.data.data.PaymentCard);
            if (PaymentCard != undefined && PaymentCard.length > 0) {
              PaymentCard.forEach((element, index) => {
                if (index == 0) {
                  this.PaymentCard = element.BankName;
                  this.PaymentAccount = element.Account;
                } else if (index < 3) {
                  this.PaymentCard = this.PaymentCard + '，' + element.BankName;
                  this.PaymentAccount = this.PaymentAccount + '，' + element.Account;
                } else if (index == 3) {
                  this.PaymentCard = this.PaymentCard + '...'
                  this.PaymentAccount = this.PaymentAccount + '...'
                }
              });

              let ReceivedBankCard = eval(res.data.data.ReceivedBankCard)
              if (ReceivedBankCard != undefined && ReceivedBankCard.length > 0) {
                ReceivedBankCard.forEach((element, index) => {
                  if (index == 0) {
                    this.ReceivedBankCard = element.BankType;
                    this.ReceivedAccountNo = element.AccountNo;
                  } else if (index < 3) {
                    this.ReceivedBankCard = this.ReceivedBankCard + '，' + element.BankType;
                    this.ReceivedAccountNo = this.ReceivedAccountNo + '，' + element.AccountNo;
                  } else if (index == 3) {
                    this.ReceivedBankCard = this.ReceivedBankCard + '...'
                    this.ReceivedAccountNo = this.ReceivedAccountNo + '...'
                  }
                });
              }
            }
          } else {
            this.$message.error('获取详情出错')
            this.baseInfo = {};
            this.tableData = []
          }
        })
      },
      //获取到款信息
      getPaymentInfo() {
        if (!this.showPaymentInfo) {
          let expandQuery = {
            ids: this.baseInfo.AssociatedClaim
          }
          xz.getClaimRecordList(expandQuery, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.PaymentData = res.data.data;
            } else {
              this.PaymentData = [];
            }
          })
        }
        this.showPaymentInfo = !this.showPaymentInfo;

      },
      //下载
      down(url) {
        var path = this.headPath + url;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      changeTab() {
        if (this.activeName2 == '0') {
          this.getApplicationPayrollDetail();
        } else {
          this.getGenerWorkerList();
        }
      },
      //获取工作流
      getGenerWorkerList() {
        if (this.listQuery.WorkId) {
          xz.getGenerWorkerList(this.listQuery.WorkId, this.roletype).then(res => {
            if (res.status == 'ok') {
              if (res.data.WF_GenerWorkerList != undefined) {
                res.data.WF_GenerWorkerList.sort((a, b) => a.FK_Node - b.FK_Node);
                this.WorkerList = res.data.WF_GenerWorkerList;
                res.data.WF_GenerWorkerList.forEach((element) => {
                  this.$set(element, 'title', element.FK_NodeText)
                  this.$set(element, 'description', element.FK_EmpText + element.RDT)
                });
                let l = res.data.WF_GenerWorkerList.length;
                this.$set(res.data.WF_GenerWorkerList[l - 1], 'description', res.data.WF_GenerWorkFlow[0].TodoEmps)
                this.TrackList = res.data.Track;
              } else if (this.baseInfo.ProcessState == '出纳确认' || this.baseInfo.ProcessState == '部分发薪' || this.baseInfo.ProcessState == '待发薪') {
                this.WorkerList = []
                res.data.Track.forEach((element, index) => {
                  if (element.ActionTypeText != '流程结束') {
                    let data = {
                      title: element.NDFromT,
                      description: element.EmpFromT + element.RDT
                    }
                    this.WorkerList.push(data);
                  } else {
                    res.data.Track.splice(index, 1);
                  }
                });
                this.TrackList = res.data.Track;
                setTimeout(() => {
                  let data2 = {
                    title: '出纳确认',
                    description: this.baseInfo.Cashier
                  }
                  this.WorkerList.push(data2)
                }, 100);
              }
              // if (res.data.Track.length > 0) {
              //   let arr = [];
              //   let num = 0;
              //   res.data.Track.forEach((element, index) => {
              //     if (element.Msg.indexOf('WorkCheck@') > -1) {
              //       element.Msg = element.Msg.split('WorkCheck@')[1]
              //     }
              //     if (element.ActionType == '1' || element.ActionType == '8') {
              //       arr.push(element)
              //       this.$set(this.WorkerList[num], 'description', element.EmpFromT + ' ' + element.RDT)
              //       num++;
              //     }

              //     if (index + 1 == res.data.Track.length) {
              //       this.TrackList = arr;
              //       this.$set(this.WorkerList[arr.length], 'description', res.data.WF_GenerWorkFlow[0].TodoEmps)

              //       console.log(res.data.Track, this.TrackList)
              //     }
              //   })
              // }
            } else {
              this.WorkerList = [];
              this.TrackList = [];
              this.$message.error('获取工作流出错')
            }
          })
        } else {
          this.TrackList = [{
            RDT: this.baseInfo.CreateTime.replace('T', ' '),
            NDFromT: '客服发起',
            Msg: this.baseInfo.ApplicationRemarks,
            EmpFromT: this.baseInfo.Operator
          }];
          this.WorkerList = [{
            title: '客服发起',
            description: this.baseInfo.Operator + this.baseInfo.CreateTime.replace('T', ' '),
          }, {
            title: '出纳确认',
            description: this.baseInfo.Cashier,
          }, {
            title: '待打款',
            description: '',
          }, {
            title: '部分打款',
            description: '',
          }, {
            title: '已打款',
            description: '',
          }]
        }

      },
      //同意
      agree() {
        // let id = this.baseInfo.WorkId;
        this.btnLoading = true;
        this.sysQuery.id = this.listQuery.id;
        this.sysQuery.PageNumber = 1;
        xz.AdvanceFun(this.sysQuery, 'GetRiskAlertListById').then(res => {
          try {
            if (res.status == 'ok') {
              if (res.data.retList.length > 0) {
                this.sysTipsData = res.data.retList;
                this.sysTotal = res.data.totalCount;
                this.showSysTips = true;
                this.btnLoading = false;
              } else {
                this.getAppBatch();
              }
            } else {
              this.$message.error(res.msg);
              this.btnLoading = false;
            }
          } catch (e) {
            console.log(e)
            this.btnLoading = false;
            this.$message.error('系统出错')
          }
        })
      },
      currentChangeSys(val) {
        this.sysQuery.PageNumber = Number(val);
        this.getSysData();
      },
      handleSizeChangeSys(val) {
        console.log(`每页 ${val} 条`);
        this.sysQuery.PageNumber = 1;
        this.sysQuery.PageSize = val;
        this.getSysData();
      },
      getSysData() {
        this.sysLoading = true;
        xz.AdvanceFun(this.sysQuery, 'GetRiskAlertListById').then(res => {
          try {
            if (res.status == 'ok') {
              this.sysLoading = false;
              this.sysTipsData = res.data.retList;
              this.sysTotal = res.data.totalCount;
            } else {
              this.sysLoading = false;
              this.sysTipsData = [];
              this.sysTotal = 0;
              this.$message.error(res.msg);
            }
          } catch (e) {
            this.sysLoading = false;
            this.sysTipsData = [];
            this.sysTotal = 0;
            this.$message.error('系统出错')
          }
        })
      },
      getAppBatch() {
        xz.checkCurrentProjectSubmiTdetails(this.listQuery.id, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (res.data.length > 0) {
              res.data.forEach(element => {
                if (element.Id == this.listQuery.id) {
                  this.btnLoading = false;
                  this.ThisMonthBatch = element.ThisMonthBatch;
                  this.showApplication = true;
                }
              });
            } else {
              this.btnLoading = false;
              this.ThisMonthBatch = '1';
              this.showApplication = true;
            }
          } else {
            this.ThisMonthBatch = 1;
            this.showApplication = true;
          }
        })
      },
      confirmAgree() {
        if (this.baseInfo.ProcessState == '出纳确认' || this.baseInfo.ProcessState == '部分发薪' || this.baseInfo.ProcessState == '待发薪') {
          if (this.isNull(this.baseInfo.AssociatedClaim) && this.isNull(this.baseInfo.ApplyDeposit)) {
            this.$message.warning('无资金来源，不能审批。')
          } else {
            this.cashierConfirm('待发薪');
          }
        } else {
          this.btnLoading = true;
          let data = {
            WorkId: this.baseInfo.WorkId,
            Doc: this.form1.approveRemake
          }
          xz.aOapiNodeSendWork(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.btnLoading = false;
              this.$message.success('操作成功！');
              this.$router.go(-1);
            } else {
              this.btnLoading = false;
              this.$message.error(res.msg)
            }
          })
        }
      },
      //不同意
      disagree() {
        if (this.baseInfo.ProcessState == '出纳确认') {
          this.cashierConfirm('发薪失败');
        } else {
          if (this.form1.approveRemake) {
            let data = {
              WorkID: this.baseInfo.WorkId,
              msg: this.form1.approveRemake
            }
            xz.AOapiNodeReturnWork(data, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功！');
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.warning('请填写审批备注')
          }
        }
      },
      //出纳确认
      cashierConfirm(type) {
        this.btnLoading = true;
        let data = {
          Id: this.listQuery.id,
          ProcessState: type
        }
        xz.cashierFinancialAudit(data, this.roletype, 'cashierFinancialAudit').then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功！');
            this.btnLoading = false;
            this.$router.go(-1);
          } else {
            this.btnLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //数字转中文大写
      numberToChinese(money) {
        // if (num) {
        //   const digitMap = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
        //   const unitMap = ["", "拾", "佰", "仟", "万", "亿"];

        //   let chinese = "";
        //   let unitIndex = 0;

        //   if (num === 0) {
        //     return digitMap[0];
        //   }

        //   while (num > 0) {
        //     const digit = num % 10;
        //     if (digit !== 0 || chinese.length === 0 || chinese[0] !== digitMap[0]) {
        //       chinese = digitMap[digit] + unitMap[unitIndex] + chinese;
        //     }
        //     num = Math.floor(num / 10);
        //     unitIndex++;
        //   }

        //   return chinese.replace(/零(千|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
        // }
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      goback() {
        this.$router.go(-1);
        // window.close()
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]' ||
          o == {}
        );
      },
      //打印
      printClick(id, ignoreIds) {
        const style = '@page {margin:0 10mm};' //打印时去掉眉页眉尾
        printJS({
          printable: id, // 标签元素id
          type: 'html',
          header: '',
          targetStyles: ['*'],
          style,
        });
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .descriptions_box {
    margin-bottom: 20px;
  }

  .descriptionsTitle {
    border: 1px solid #B7BABD;
    border-bottom: none;
    // margin: 0 auto;
    padding: 8px 0;
    font-size: 13px;
    font-weight: 600;
    color: #000;
    text-align: center;
  }

  .selectCustomPayment {
    font-weight: 600;
    margin-bottom: 10px;
  }

  .dzItem {
    width: 80px;
  }

  .timelineBox {
    padding-left: 30px;
    width: 500px;
  }

  .basicInfo {
    flex-wrap: wrap;
    margin-bottom: 15px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    width: 170px;
    line-height: 32px;
  }

  .btnBox {
    padding: 20px 0 50px 0;
    width: 900px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .down {
    color: #409eff;
    margin-right: 15px;
  }

  .loongTxt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 6em;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .salaryApproval_Dialog .el-dialog__body {
    padding-top: 10px;
  }

  .salaryApproval .el-descriptions .is-bordered .el-descriptions-item__cell {
    padding: 8px 5px;
  }

  .salaryApproval .el-descriptions-item__label.is-bordered-label {
    background: #fff;
    color: #000;
    font-weight: 600;
  }

  .salaryApproval .remarkInfo .el-form--inline .el-form-item {
    margin-bottom: 0;
  }

  .page_approvalDtl .el-step__head.is-process {
    color: #FFCC33;
    border-color: #FFCC33;
  }

  .page_approvalDtl .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 1px solid #B7BABD;
  }

  .page_approvalDtl .el-step.is-vertical .el-step__main {
    min-height: 60px;
  }

  .page_approvalDtl .demandForm .el-form-item__label {
    color: #999;
  }

  .page_approvalDtl .demandForm .el-form--inline .el-form-item {
    width: 200px;
    margin-right: 0;
  }

  .page_approvalDtl .demandForm .el-form-item {
    margin-bottom: 0;
  }
</style>